module.exports = __webpack_public_path__ + "assets/img/02b151c760bff7a4b6d03040509da1c4.png";